<template>
  <v-btn
    v-on:click="showBatchDialog"
    :disabled="isDisabled"
    class="UXbtn header-btn left-btn"
    outline
  >
    一括適用
    <batch-dialog :batch-target-tickets="batchTargetTickets"
                  :call-all-ticket-list="callAllTicketList"></batch-dialog>
  </v-btn>
</template>

<script>
import batchDialog from '../dialog/batch_dialog'
import eventBus from '@/event_bus'
import event from '../../../enums/eventType'

export default {
  name: 'batch_button',
  components: {
    batchDialog
  },
  props: {
    callAllTicketList: Function,
    batchTargetTickets: Array
  },
  data: () => ({
    isDisabled: true,
    isShow: false
  }),
  watch: {
    batchTargetTickets: function (val) {
      this.isDisabled = val.length === 0
    }
  },
  methods: {
    showBatchDialog () {
      eventBus.$emit(event.OPEN_TICKET_BATCH_DIALOG)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/button/batch_button.vue